import { getCertificateCreateFieldSelector } from "raft/CertificateForm";
import { useCallback, useEffect, useMemo } from "react";
import { SetterOrUpdater, useSetRecoilState } from "recoil";
import useGetItemtext from "../SoftwareBridgeList/useGetItemtext";

const buildSoftwSoftwareList =
  (getItemtext: (id: string) => string) =>
  (softwsoftwareBridgeIds: string[]): string => {
    const softwsoftwareNumbers = softwsoftwareBridgeIds
      .map((id) => {
        return getItemtext(id);
      })
      .join(",");
    return softwsoftwareNumbers;
  };

export const useManageSoftwSoftwarelist = (useBridgeArrayState: () => [string[], SetterOrUpdater<string[]>]) => {
  const __softwsoftwareListAtomActive = useMemo(
    () => getCertificateCreateFieldSelector({ formVersion: "active" })("__softwareVersion"),
    []
  );
  const __softwsoftwareListAtomMatrix = useMemo(
    () => getCertificateCreateFieldSelector({ formVersion: "matrixCertificateCreate" })("__softwareVersion"),
    []
  );

  const setSoftwSoftwareListActive = useSetRecoilState(__softwsoftwareListAtomActive);
  const setSoftwSoftwareListMatrix = useSetRecoilState(__softwsoftwareListAtomMatrix);
  const getItemtext = useGetItemtext();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getLables = useCallback(buildSoftwSoftwareList(getItemtext), [getItemtext, buildSoftwSoftwareList]);
  const [softwsoftwareBridgeIds] = useBridgeArrayState();

  useEffect(() => {
    const softwareVersionString = getLables(softwsoftwareBridgeIds);

    // Set for both form versions to ensure compatibility
    try {
      setSoftwSoftwareListMatrix(softwareVersionString);
    } catch (e) {
      // Ignore if form doesn't exist
    }

    try {
      setSoftwSoftwareListActive(softwareVersionString);
    } catch (e) {
      // Ignore if form doesn't exist
    }
  }, [softwsoftwareBridgeIds, getLables, setSoftwSoftwareListActive, setSoftwSoftwareListMatrix]);
};
